import React from "react";
import { useNavigate } from "react-router-dom";
import bgImg from "../assets/connect-bg.jpg";

export default function Body() {
  const navigate = useNavigate();

  return (
    <main
      className="flex flex-col items-center justify-center flex-grow text-center px-4 py-10 min-h-[60vh] bg-gray-50"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="bg-white bg-opacity-80 rounded-xl p-6 shadow-md w-full max-w-2xl">
        <h2 className="text-2xl sm:text-4xl font-bold text-blue-900 mb-4">
          Connect with Lawyers Anytime, Anywhere in India 🇮🇳
        </h2>
        <p className="text-base sm:text-lg text-gray-600 max-w-2xl mb-6">
          Find trusted legal experts and resolve your issues online without
          stepping outside. Fast, secure, and professional assistance at your fingertips.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            className="bg-blue-700 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-800 transition-colors duration-200"
            onClick={() => navigate("/lawyers")}
          >
            Find a Lawyer
          </button>
          <button
            className="bg-gray-200 text-blue-700 px-6 py-3 rounded-xl shadow hover:bg-gray-300 transition-colors duration-200"
            onClick={() => navigate("/register")}
          >
            Become a Lawyer
          </button>
        </div>
      </div>
    </main>
  );
}

